import { Button, Timeline } from 'antd';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import { IPaymentLogs } from './D2RInvoiceSlider';
import { D2RPaymentType } from './PaymentForm';

export const PaymentLogs = ({ paymentLog }: { paymentLog: IPaymentLogs }) => {
	return (
		<Timeline.Item color={paymentLog.remarks.includes('closed') ? 'red' : 'blue'}>
			<div className={styles.paymentLogContainer}>
				<div className={styles.mainContent}>
					<span className={styles.remarks}>{paymentLog.remarks}</span>

					{paymentLog?.proofUrl && paymentLog?.proofUrl !== 'NA' ? (
						<Button
							size="small"
							className={styles.proofButton}
							onClick={() => {
								window.open(
									`${
										paymentLog.mode === D2RPaymentType.CN_ADJUSTED
											? `https://wherehouse-prod-content.s3.ap-south-1.amazonaws.com/${paymentLog?.proofUrl}`
											: paymentLog.proofUrl
									}`,
									'_blank'
								);
							}}
						>
							Proof
						</Button>
					) : null}
				</div>
				{paymentLog.reason && <span className={styles.reason}>Reason : {paymentLog.reason}</span>}

				{paymentLog?.createdAt && <span className={styles.date}>{dayjs(paymentLog.createdAt).format('MMM DD, YYYY hh:mm A')}</span>}
			</div>
		</Timeline.Item>
	);
};
